import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter as Router } from 'react-router-dom';
import 'rsuite/dist/rsuite.min.css';
import 'bootstrap/dist/css/bootstrap.css';
//import 'draft-js/dist/Draft.css'; 
import './assets/base.css';
import './assets/custom.css';
import './Components/Settings/settings.css';
import 'video-react/dist/video-react.css';
import reportWebVitals from './reportWebVitals';
import Main from "./Main";
//import Main from "./Main/indexSite"; //enable this if you want to build login app and disable regular main
import {Provider} from "react-redux";
import configureStore from './config/configureStore';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'

const store = configureStore();
const root = ReactDOM.createRoot(document.getElementById('root'));

// This exports the whole icon packs for Brand and Solid.
library.add(fab, fas)
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js').then((registration) => {
      console.log('Service Worker registered with scope:', registration.scope);
    }).catch((error) => {
      console.error('Service Worker registration failed:', error);
    });
  }
root.render(
    <Provider store={store}>
        <Router basename="/">
            <Main />
        </Router>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
